import Layout from '@/layout'

const AirImportRouter = {
  path: '/AirImport',
  component: Layout,
  redirect: 'noredirect',
  name: 'AirImport',
  meta: {
    title: '空运进口',
    icon: 'daohang-ziliaoguanli'
  },
  children: [
    {
      path: 'AiBooking',
      component: () => import('@/views/cargo/v0/AirImport/aiBooking'),
      name: 'AiBooking',
      meta: { title: '空运操作' },
      roles: ['module_AIBooking']
    }, {
      path: 'AiOrder',
      component: () => import('@/views/cargo/v0/AirImport/aiOrder'),
      name: 'AiOrder',
      meta: { title: '预报' },
      roles: ['module_Order']
    },
    {
      path: 'ImportCharge',
      component: () => import('@/views/cargo/v0/AirImport/ImportCharge/index'),
      name: 'ImportCharge',
      meta: { title: '批量导入费用(空进)' },
      roles: ['module_fmImportChargeAI']
    },
    {
      path: 'AIBatchUploadFile',
      component: () => import('@/views/cargo/v0/AirImport/uploadFile/index'),
      name: 'AIBatchUploadFile',
      meta: { title: '上传文件' },
      roles: ['module_AirImportUploadFile']
    },
    {
      path: 'WarehouseModule',
      component: () => import('@/views/cargo/v0/AirImport/WarehouseModule/index'),
      name: 'WarehouseModule',
      meta: { title: '仓库操作' },
      roles: ['module_AirImportWarehouse']
    }
  ]
}

export default AirImportRouter
